module.exports = __webpack_public_path__ + "img/jlsq.e2db8c96.png";